module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title":"Users","new_resource":"New User"},"pt-BR":{"title":"Usuários","new_resource":"Novo Usuário"}}')
  delete Component.options._Ctor
}
